import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../hooks/useAdminAuth';
import { getChatConversations } from '../../api/client';
import './Admin.css';

export default function AdminShell({ title, children }) {
  const { logout } = useAdminAuth();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  // Poll unread count every 10s
  useEffect(() => {
    async function checkUnread() {
      try {
        const data = await getChatConversations();
        const total = (Array.isArray(data) ? data : []).reduce((s, c) => s + (c.unread_count || 0), 0);
        setUnreadCount(total);
      } catch {}
    }
    checkUnread();
    const interval = setInterval(checkUnread, 10000);
    return () => clearInterval(interval);
  }, []);

  function handleLogout() {
    logout();
    navigate('/admin/login');
  }

  function handleNavClick() {
    setMobileOpen(false);
  }

  const chatLabel = unreadCount > 0 ? `💬 Чат (${unreadCount})` : '💬 Чат';

  return (
    <div className="admin-shell">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-logo">🏠 Управление</div>
        <nav className="admin-nav">
          <NavLink to="/admin" end className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}>
            📊 Дашборд
          </NavLink>
          <NavLink to="/admin/bookings" className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}>
            📋 Бронирования
          </NavLink>
          <NavLink to="/admin/apartments" className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}>
            🏠 Квартиры
          </NavLink>
          <NavLink to="/admin/chat" className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}>
            {chatLabel}
            {unreadCount > 0 && <span className="nav-unread-dot" />}
          </NavLink>
        </nav>
        <div className="admin-sidebar-footer">
          <button onClick={handleLogout} className="btn btn-secondary" style={{ width: '100%', fontSize: 13, padding: '10px 16px' }}>
            Выйти
          </button>
        </div>
      </aside>

      <main className="admin-main">
        <div className="admin-topbar">
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <button className="mobile-menu-btn" onClick={() => setMobileOpen(!mobileOpen)}>
              {mobileOpen ? '✕' : '☰'}
              {!mobileOpen && unreadCount > 0 && <span className="burger-dot" />}
            </button>
            <h1>{title}</h1>
          </div>
        </div>

        {mobileOpen && (
          <>
            <div className="mobile-overlay" onClick={() => setMobileOpen(false)} />
            <div className="mobile-menu">
              <NavLink to="/admin" end className={({ isActive }) => `mobile-nav-link ${isActive ? 'active' : ''}`} onClick={handleNavClick}>
                📊 Дашборд
              </NavLink>
              <NavLink to="/admin/bookings" className={({ isActive }) => `mobile-nav-link ${isActive ? 'active' : ''}`} onClick={handleNavClick}>
                📋 Бронирования
              </NavLink>
              <NavLink to="/admin/apartments" className={({ isActive }) => `mobile-nav-link ${isActive ? 'active' : ''}`} onClick={handleNavClick}>
                🏠 Квартиры
              </NavLink>
              <NavLink to="/admin/chat" className={({ isActive }) => `mobile-nav-link ${isActive ? 'active' : ''}`} onClick={handleNavClick}>
                {chatLabel}
              </NavLink>
              <button onClick={handleLogout} className="mobile-nav-link" style={{ border: 'none', background: 'none', width: '100%', textAlign: 'left', cursor: 'pointer', color: 'var(--danger)' }}>
                🚪 Выйти
              </button>
            </div>
          </>
        )}

        <div className="admin-content">{children}</div>
      </main>
    </div>
  );
}